export class AuthUtils {
    
    static encodeEmailAndPassword(email: string, password: string): string {
        const encoder = new TextEncoder();

        const encodedEmail = encoder.encode(email);
        const encodedPassword = encoder.encode(password);

        const encodedEmailBase64 = btoa(String.fromCharCode(...encodedEmail));
        const encodedPasswordBase64 = btoa(String.fromCharCode(...encodedPassword));

        return `${encodedEmailBase64}.${encodedPasswordBase64}`;
    }

    static decodeAuthCode(authCode: string): { email: string, password: string } {
        const [encodedEmail, encodedPassword] = authCode.split('.');

        const email = atob(encodedEmail);
        const password = atob(encodedPassword);

        const decoder = new TextDecoder();
        const decodedEmail = decoder.decode(new Uint8Array([...email].map(char => char.charCodeAt(0))));
        const decodedPassword = decoder.decode(new Uint8Array([...password].map(char => char.charCodeAt(0))));

        return { email: decodedEmail, password: decodedPassword };
    }

    static encodeToBase64(input: string): string {
        const encoder = new TextEncoder();  
        const encodedBytes = encoder.encode(input);  
        const byteString = String.fromCharCode(...encodedBytes);  
        return btoa(byteString); 
    }

    static decodeFromBase64(encoded: string): string {
        var decodedString;
        try{
            decodedString = atob(encoded);
        }
        catch(error){
            return ''
        }
        const bytes = new Uint8Array([...decodedString].map(char => char.charCodeAt(0)));
        const decoder = new TextDecoder();
        return decoder.decode(bytes);
    }
    
}